import React, { ReactNode, FC } from 'react'
import { Flex } from '@chakra-ui/react'

const styleBox = {
  bg: 'tertiary.30',
  borderRadius: '12px',
  marginBottom: '30px',
  minHeight: '128px',
  justifyContent: 'space-between',
  padding: '27px',
  alignItems: 'center',
}

const styleBoxTwo = {
  ...styleBox,
  flexShrink: '0',
  flexGrow: '1',
  minH: '88px'
}

interface CardLeftProps {
  children?: ReactNode;
  icon?: ReactNode;
  [x: string]: unknown;
}

const CardLeft : FC<CardLeftProps> = ({ children, icon }) => (
  <Flex {...styleBoxTwo} mr='12px' flex='4'>
    <Flex textStyle='titleSmBold' flexGrow='1' alignItems='center'>
      {icon}
      <Flex pl='15px' alignItems='center' flexGrow='1'>{children}</Flex>
    </Flex>
  </Flex>
)

export default CardLeft
